import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ValidatorModel, ValidatorsHelper} from '../../../core/helpers/validators.helper';
import {CustomInput, PasswordValidatorType} from '../kamona-input-field/kamona-input-field.component';
import {StringHelper} from '@mpt-fo/common/core/helpers/strings.helper';

@Component({
	selector: 'app-kamona-password-input',
	templateUrl: './kamona-password-input.component.html',
	styleUrls: ['./kamona-password-input.component.scss']
})
export class KamonaPasswordInputComponent implements OnInit {
	inputValue: any;
	@Input() input: any;
	@Output() emitInput = new EventEmitter();
	readonly IS_VALID_INPUT = 'valid';
	readonly ERROR_CLASS = 'in-valid';
	validationError: boolean;
	placeHolder = ' ';
	label: string;
	datePlaceHolder = ' ';
	passwordValidatorType = PasswordValidatorType;
	passwordValidators: Array<ValidatorModel> = ValidatorsHelper.getPasswordValidators();
	isPasswordVisible: boolean;
	validInput: any;

	constructor() {
	}

	ngOnInit(): void {
		this.initialize();
	}

	initialize() {
		this.input = this.input || this.initializeInput();
		this.label = this.input.getLabel();
		if (this.input?.getInput()) {
			this.validInput = this.input.validate();
			this.inputValue = this.input.getInput();
		}
	}

	showPasswordHintPopup() {
		const isCustom = this.input?.validatorType === this.passwordValidatorType.CUSTOM;
		return !this.input.validate() && isCustom;
	}

	showPasswordHint() {
		const isPinType = this.input?.validatorType === PasswordValidatorType.PIN;
		const isValidInput = !this.input.isError && !this.validationError;
		const canShowHint = this.input?.showPasswordHint;
		return isPinType && isValidInput && canShowHint;
	}

	initializeInput() {
		return new CustomInput(null, null, true);
	}

	onChangePassword($event) {
		let input = $event?.target?.value;
		if (this.input?.validatorType === PasswordValidatorType.PIN) {
			input = StringHelper.numbersOnly(input);
			$event.target.value = input;
		}
		this.onPasswordChange(input);
	}


	onPasswordChange(input) {
		this.input.setInput(input);
		this.setPasswordValidator(this.input.getInput());
		const validInput = this.input.validate();
		validInput ? this.setValidPasswordAfterValidation() : this.setPasswordErrorAfterValidation();
		this.emitInput.emit(this.input);
	}


	setValidPasswordAfterValidation() {
		this.removePasswordErrorClass();
		this.placeHolder = ' ';
		this.addPasswordFloatingClass();
		this.validationError = false;
	}

	setPasswordErrorAfterValidation() {
		this.removePasswordFloatingClass();
		this.placeHolder = this.input.getPlaceHolder() || this.input.getLabel();
		this.addPasswordErrorClass();
		this.validationError = true;
	}

	addPasswordErrorClass() {
		if (!this.input?.getLabel()) {
			return;
		}
		document.getElementById(`kamona-password-input-field-${this.input?.getLabel()}`)?.classList?.add(this.ERROR_CLASS);
	}

	removePasswordErrorClass() {
		if (!this.input?.getLabel()) {
			return;
		}
		document.getElementById(`kamona-password-input-field-${this.input?.getLabel()}`)?.classList?.remove(this.ERROR_CLASS);
	}

	removePasswordFloatingClass() {
		if (!this.input?.getLabel()) {
			return;
		}
		document.getElementById(`kamona-password-input-field-${this.input?.getLabel()}`)?.classList?.remove(this.IS_VALID_INPUT);
	}

	addPasswordFloatingClass() {
		if (!this.input?.getLabel()) {
			return;
		}
		document.getElementById(`kamona-password-input-field-${this.input?.getLabel()}`)?.classList?.add(this.IS_VALID_INPUT);
	}

	setPasswordValidator(password) {
		this.passwordValidators = this.input.validatorType === PasswordValidatorType.CUSTOM ?
			ValidatorsHelper.validatePassword(password) : [];
	}

	togglePassword() {
		const password = document.getElementById(`kamona-password-input-field-${this.input.getLabel()}`);
		password[`type`] === 'password' ?
			password[`type`] = 'text' :
			password[`type`] = 'password';
		this.isPasswordVisible = password[`type`] === 'text';
	}

	validateCustomPassword(regex: string) {
		return RegExp(regex).test(this.input.getInput());
	}

	onFocus() {
		document.getElementById(`kamona-password-input-field-${this.input.getLabel()}`).focus();
	}

}
